import { useSurveyStore } from "../../store";
import { ConditionsList } from "./slices/conditions-list";
import { ConditionEdit } from "./slices/condition-edit";

export const ConditionsSlice = () => {
  const activeConditionIdx = useSurveyStore(
    (state) => state.activeConditionIdx
  );
  const isEditing = activeConditionIdx !== null;

  return (
    <main className="animate-appear bg-white h-[calc(100vh-72px)]">
      {isEditing ? <ConditionEdit /> : <ConditionsList />}
    </main>
  );
};
